import { render, staticRenderFns } from "./DonutRing.vue?vue&type=template&id=068eb4e7&scoped=true"
import script from "./DonutRing.vue?vue&type=script&lang=ts"
export * from "./DonutRing.vue?vue&type=script&lang=ts"
import style0 from "./DonutRing.vue?vue&type=style&index=0&id=068eb4e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068eb4e7",
  null
  
)

export default component.exports